module.exports = __webpack_public_path__ + "static/media/WAStateElection2025LogoMobile.9aab56ff.svg";